let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hr9YX")).then(() => parcelRequire('c4BxZ'));